import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, isRef as _isRef, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "author"
}
const _hoisted_2 = {
  key: 0,
  class: "font-weight-bold mr-2"
}
const _hoisted_3 = {
  key: 1,
  class: "opacity05 location text-nowrap"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 3,
  class: "answer"
}
const _hoisted_7 = {
  key: 0,
  class: "font-weight-bold mb-2"
}

import {computed, ref} from 'vue';
import IReview from "~/chat/ts/service/reviews/IReview";
import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import ReviewValue from "~/chat/vue/widget/tabs/reviews/ReviewValue.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import ChatDateHelper from "~/chat/ts/service/ChatDateHelper";
import {__} from "~/ts/library/Translate";
import ReviewWrapper from "~/chat/vue/widget/tabs/reviews/ReviewWrapper.vue";


const __default__ = {
    name: "Review"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    review: {},
    displayName: { type: Boolean, default: true },
    displayDate: { type: Boolean, default: true },
    displayCity: { type: Boolean, default: true },
    displayRateValue: { type: Boolean, default: true },
    maxLength: {}
  },
  setup(__props: any) {

let props = __props;


let showFull = ref(false);


let location = computed<string>(() => {
    let result = null;
    if (props.displayCity) {
        if (props.review.city) {
            result = props.review.city;
        } else if (props.review.country) {
            result = props.review.country;
        }
    }
    return result;
});

let answerDescr = computed(() => {
    let result = ConfigStore.siteParams.value.params.rate.adminCommentTitle;
    return result && result.length ? result : null;
});

let comment = computed(() => {
    let result = props.review.comment;
    if (result && !showFull.value && props.maxLength > 0 && result.length > props.maxLength) {
        result = result.substr(0, props.maxLength) + "...";
    }
    return result;
});

let isCut = computed(() => {
    return props.review.comment != comment.value;
});

let descr = computed(() => {
    let descr = null;
    if (props.displayName) {
        descr = props.review.descr;
        if (descr) {
            descr = descr.split(", 8000")[0];
        }
    }
    return descr;
});

function toLocaleDate(dt: string) {
    return (new ChatDateHelper(dt)).toLocaleDateString();
}

function toMysqlDate(dt: string | Date) {
    return (new ChatDateHelper(dt)).toMysqlFormatDate();
}

let date = computed(() => {
    let date = new Date();
    let today = toMysqlDate(date);
    let reviewDate = toMysqlDate(props.review.dt);
    if (reviewDate >= today) {
        reviewDate = __("TODAY");
    } else {
        date.setTime(date.getTime() - 86400000);
        let yesterday = toMysqlDate(date);
        if (reviewDate >= yesterday) {
            reviewDate = __("YESTERDAY");
        } else {
            reviewDate = toLocaleDate(props.review.dt)
        }
    }
    return reviewDate;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ReviewWrapper, null, {
    default: _withCtx(() => [
      (_ctx.displayDate)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({
                'opacity05': true,
                'font-size-small': true,
                'float-right  ml-4': _unref(descr) || _unref(location) || _ctx.displayRateValue,
                'date': true
            })
          }, _toDisplayString(_unref(date)), 3))
        : _createCommentVNode("", true),
      (_unref(descr) || _unref(location))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(descr))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(descr)), 1))
              : _createCommentVNode("", true),
            (_unref(location))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(location)), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayRateValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ReviewValue, {
              class: "value",
              "model-value": _ctx.review.rate
            }, null, 8, ["model-value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({
            'text': true,
            margin: _unref(descr) || _unref(location) || _ctx.displayRateValue || _ctx.displayDate
        })
      }, [
        (_unref(comment))
          ? (_openBlock(), _createBlock(Htmlify, {
              key: 0,
              value: _unref(comment),
              escape: false,
              snippet: "",
              links: ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_unref(isCut))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showFull) //@ts-ignore
 ? showFull.value = true : showFull = true))
              }, _toDisplayString(_unref(__)("READ_MORE")), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.review.adminComment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", null, [
              (_unref(answerDescr))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(answerDescr)), 1))
                : _createCommentVNode("", true),
              _createVNode(Htmlify, {
                value: _ctx.review.adminComment,
                escape: false,
                links: "",
                snippet: ""
              }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})